import { h, Fragment } from "preact";
import useProductGroup from "../helpers/useProductGroup/useProductGroup";
import ProductSwatch from "./product-swatch";

export default function ProductSwatches({
  groupName,
  productId,
  showLabels,
  onlyActive,
}) {
  const [productGroup] = useProductGroup(groupName);

  return (
    <>
      {productGroup
        .filter((product) => {
          if (!onlyActive) return true;

          return product.id === productId;
        })
        .map((product, i) => (
          <ProductSwatch
            product={product}
            active={product.id === productId}
            showLabel={showLabels}
          />
        ))}
    </>
  );
}
